/** REACT */
import React from 'react'
/* import classnames from 'classnames' */
import PropTypes from 'prop-types'

/** FONTAWESOME 5 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab, faFacebook, faWhatsapp, faTwitter, faVk, faTelegram } from '@fortawesome/free-brands-svg-icons'
import {
  faCircle,
  faArrowRight,
  faArrowLeft,
  faExpand,
  faTimes,
  faCheck,
  faAngleDoubleLeft,
  faChevronDown,
  faBars,
  faEnvelope,
  faFileSignature,
  faChalkboardTeacher,
  faProjectDiagram,
  faHandsHelping,
  faArrowAltCircleLeft,
  faRedo,
  faCloudUploadAlt,
  faDownload,
} from '@fortawesome/free-solid-svg-icons'
import { faCopyright, faUser, faPlusSquare } from '@fortawesome/free-regular-svg-icons'

library.add(
  fab,
  faCircle,
  faCopyright,
  faArrowRight,
  faArrowLeft,
  faUser,
  faExpand,
  faTimes,
  faCheck,
  faAngleDoubleLeft,
  faChevronDown,
  faBars,
  faEnvelope,
  faHandsHelping,
  faFileSignature,
  faChalkboardTeacher,
  faProjectDiagram,
  faArrowAltCircleLeft,
  faPlusSquare,
  faRedo,
  faCloudUploadAlt,
  faDownload,
  faFacebook,
  faWhatsapp,
  faTwitter,
  faVk,
  faTelegram
)

/** STYLES */
/* import style from './defaultLayout.module.scss' */

/** COMPONENTS */
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import style from './defaultLayout.module.scss'
import Helmet from 'react-helmet'
/*import { YMInitializer } from 'react-yandex-metrika'*/

class DefaultLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  render() {
    const { children } = this.props

    return (
      <>
        <Helmet
          meta={[{ charset: 'utf-8' }]}
        />
        {/*<YMInitializer accounts={[41251794]} options={{ webvisor: true, trackHash: true }} version="2" />*/}
        <div className={style.siteContainer}>
          <Header />
          <main className={style.mainContainer}>
            {children}
          </main>
          <Footer />
        </div>
      </>
    )
  }
}

export default DefaultLayout
